import { usePortletConfig } from 'js/components/system/Portlet';
import { useAppSelector } from 'js/store/hooks';
import { prop, split, reduce, pipe, isEmpty } from 'ramda';
import { useMemo } from 'react';

const formatGamesConfigTag = (jackpotsConfigTag: string) => {
    if (!jackpotsConfigTag) {
        return {};
    }

    return pipe(
        split(','),
        reduce((acc, key) => ({
            ...acc,
            [key]: true
        }), {})
    )(jackpotsConfigTag);
};

export const useJackpotsConfiguration = () => {
    const portletConfig = usePortletConfig() as Record<string, unknown>;
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const globalJackpotsConfigTag = dynamicTags.DTAG_GLOBAL_GAME_JACKPOT_SETTINGS;

    const jackpotConfigFromTags = useMemo(
        () => formatGamesConfigTag(globalJackpotsConfigTag),
        [globalJackpotsConfigTag]
    );

    const { portletType } = portletConfig;

    // in case we use it outside of game portlet,
    // configuration will be returned from the GLOBAL_GAME_JACKPOT_SETTINGS Dynamic tag
    return useMemo(() => !isEmpty(portletConfig) && portletType === 'responsivegames'
        ? portletConfig : jackpotConfigFromTags, [jackpotConfigFromTags, portletConfig, portletType]);
};
